import { Button, Col, Row } from 'antd';
import classNames from 'classnames/bind';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Table from '~/components/Common/Table';
import LoadingView from '~/components/Loading';
import { DEFAULT_PER_PAGE } from '~/constants/common';
import PATH from '~/constants/path';
import Content from '~/layouts/Content';
import { RootState } from '~/store/store';

import { columns, ColumnsProps } from './columns';
import FilterListEvent, { FilterListEventProps } from './filter';
import styles from './index.module.scss';
import { RoleName } from '~/models/common';

export type { FilterListEventFormValues } from './filter';

const cx = classNames.bind(styles);

interface IProps extends ColumnsProps, FilterListEventProps {
  handleChangePage: (page: number) => void;
  handleSort?: (sort: any) => void;
  isAdmin?: boolean;
}

const ListEventView = ({
  handleChangePage,
  handleDelete,
  handleFilter,
  handleSort,
  isAdmin,
}: IProps): React.ReactElement => {
  const { t } = useTranslation();
  const loading = useSelector((state: RootState) => state.event.loading);
  const currentUser = useSelector((state: any) => state.auth.userInfo);
  const isSystemAdmin = currentUser?.userRoles?.includes(RoleName.SystemAdmin);
  const listEvent = useSelector(
    (state: RootState) => state.event.listEvent?.data,
  );
  const totalData = useSelector(
    (state: RootState) => state.event.listEvent?.pagination?.total,
  );
  const currentPage = useSelector(
    (state: RootState) => state.event.listEvent?.pagination?.currentPage,
  );
  const navigate = useNavigate();
  const handleClickCreate = (): void => {
    navigate(PATH.event[isSystemAdmin ? 'system' : 'company'].create);
  };

  useEffect(() => {
    if (listEvent.length === 0 && currentPage > 1) {
      handleChangePage(1);
    }
  }, [currentPage, totalData]);

  const handleTableChange = (_, __, sort): void => {
    const { columnKey, field, order } = sort;
    handleSort?.({ columnKey, field, order });
  };

  return (
    <>
      <LoadingView loading={loading} />
      <Content title={t('event.list.title')!}>
        <div className={cx('event-wrapper')}>
          <FilterListEvent handleFilter={handleFilter} isAdmin={isAdmin} />
          <div className={cx('table-wrapper')}>
            <Row>
              <Col
                className={cx('btn-create')}
                lg={{ span: 3, offset: 21 }}
                sm={{ span: 8, offset: 16 }}
              >
                <Button type="primary" onClick={handleClickCreate}>
                  {t('event.list.btn-create')!}
                </Button>
              </Col>
            </Row>
            <Table
              columns={columns({
                handleDelete,
                isAdmin,
              })}
              dataSource={listEvent}
              rowKey="id"
              pagination={{
                showSizeChanger: false,
                pageSize: DEFAULT_PER_PAGE,
                current: currentPage,
                total: totalData,
                onChange: handleChangePage,
                position: ['bottomCenter'],
              }}
              className={cx('table')}
              scroll={{ x: 1120 }}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Content>
    </>
  );
};

export default ListEventView;
